
import type { RouteObject } from "react-router-dom";
import Home from "../pages/home/page";
import NotFound from "../pages/NotFound";
import ArticlePage from "../pages/article/page";
import CheckoutPage from "../pages/checkout/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/:id",
    element: <ArticlePage />,
  },
  {
    path: "/checkout",
    element: <CheckoutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
